/**
 * Absolute URLs for the site's social preview images.
 *
 * These point at the optimised, CDN-served asset URLs (immutable, cached
 * forever) instead of hand-written /og/*.jpg paths, which do not exist in
 * /public and returned 404s to crawlers and social scrapers.
 */
const ORIGIN = "https://rajshamani.life";

export const OG_IMAGES = {
  default: `${ORIGIN}/__l5e/assets-v1/4d702d47-9f07-4958-aa4d-cec3235d2687/og-default.jpg`,
  book: `${ORIGIN}/__l5e/assets-v1/adbb3be6-adb3-4452-bcdb-2ec61d2c8743/og-book.jpg`,
  podcast: `${ORIGIN}/__l5e/assets-v1/41ab8a52-52fd-4f68-937a-5f4dec00c4d5/og-podcast.jpg`,
  ventures: `${ORIGIN}/__l5e/assets-v1/f96c7871-158d-4f3b-b229-03c533af2f1c/og-ventures.jpg`,
} as const;

/** About-style pages reuse the default portrait card. */
export const OG_ABOUT = OG_IMAGES.default;
